// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__gfYTx","col":"Table_col__xqmia","fulfillmentStatus":"Table_fulfillmentStatus__22jLd","emailCol":"Table_emailCol__15A8L"};